import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

const NAV_LINKS = [
  { to: '/', label: 'Inicio', end: true },
  { to: '/resenas', label: 'Reseñas' },
  { to: '/que-leer', label: 'Qué leer' },
  { to: '/viajes-literarios', label: 'Viajes literarios' },
  { to: '/ferias-eventos', label: 'Ferias y eventos' },
  { to: '/podcast', label: 'Podcast' },
  { to: '/trabaja-conmigo', label: 'Trabaja conmigo' },
  { to: '/sobre-mi', label: 'Sobre mí' }
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="site-header__bar">
        <span className="site-header__spacer" aria-hidden="true" />
        <NavLink to="/" className="site-header__brand" onClick={() => setMenuOpen(false)}>
          Libros para Viajeros
        </NavLink>
        <button
          type="button"
          className="site-header__toggle"
          aria-expanded={menuOpen}
          aria-controls="main-navigation"
          onClick={() => setMenuOpen((open) => !open)}
        >
          Menú
        </button>
      </div>
      <p className="site-header__tagline">Leer. Viajar. Descubrir.</p>
      <nav id="main-navigation" className={`site-header__nav ${menuOpen ? 'is-open' : ''}`}>
        {NAV_LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) => (isActive ? 'is-active' : undefined)}
            onClick={() => setMenuOpen(false)}
          >
            {link.label}
          </NavLink>
        ))}
        <NavLink to="/buscar" className="site-header__search" onClick={() => setMenuOpen(false)}>
          Buscar
        </NavLink>
      </nav>
    </header>
  );
}

export default Header;
